var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20837 4.59653C2.42444 4.58333 2.69081 4.58333 3.03337 4.58333H5.96671C6.30927 4.58333 6.57565 4.58333 6.79171 4.59653M2.20837 4.59653C1.93873 4.61299 1.74742 4.65002 1.58414 4.73321C1.32541 4.86502 1.11507 5.07535 0.98324 5.33408C0.833374 5.62824 0.833374 6.01324 0.833374 6.78333V7.425C0.833374 8.19509 0.833374 8.58009 0.98324 8.87425C1.11507 9.13298 1.32541 9.34331 1.58414 9.47513C1.87826 9.625 2.2633 9.625 3.03337 9.625H5.96671C6.7368 9.625 7.1218 9.625 7.41596 9.47513C7.67469 9.34331 7.88502 9.13298 8.01683 8.87425C8.16671 8.58009 8.16671 8.19509 8.16671 7.425V6.78333C8.16671 6.01324 8.16671 5.62824 8.01683 5.33408C7.88502 5.07535 7.67469 4.86502 7.41596 4.73321C7.25265 4.65002 7.06134 4.61299 6.79171 4.59653M2.20837 4.59653V3.66667C2.20837 2.40102 3.23439 1.375 4.50004 1.375C5.76568 1.375 6.79171 2.40102 6.79171 3.66667V4.59653",
    stroke: "#43455E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c0d0e5f9798536ee347cfa0ac9274b91.svg";
export { ForwardRef as ReactComponent };